import React from "react";
import EADialog from "../../../../components/common/EADialog";
import { Typography } from "@mui/material";
import i18next from "i18next";
const ActivationWarningDialog = ({ isOpen, onClose, onValidateSuccess, source }) => {
  return (
    <EADialog
      isOpen={isOpen}
      title={i18next.t("rules.warningDialog.title")}
      onCancel={() => {
        onClose();
      }}
      validateBtnLabel= {i18next.t("activate")}
      onValidate={onValidateSuccess}
      hasActions={true}
      fullWidth={true}
      maxWidth="popupsm"
    >
      <Typography variant="body2" sx={{whiteSpace: "pre-line"}}>
        {i18next.t("rules.warningDialog.caption", {source})}
      </Typography>
    </EADialog>
  );
};

export default ActivationWarningDialog;
